import { Pipe, PipeTransform } from '@angular/core';
import { getTimeOffset, isDefined, isIsoDateTime, isIsoDateTimeTz, isIsoTimeTz } from '@softline/core';

@Pipe({
    name: 'utcOffset',
    pure: true,
    standalone: false
})
export class UtcOffsetPipe implements PipeTransform {
  transform(value: string | null | undefined): string | null | undefined {
    if (!isDefined(value))
      return value;
    if(isIsoDateTimeTz(value) || isIsoTimeTz(value))
      return getTimeOffset(value);
    return 'Z';
  }
}
